import React from 'react';

export const BellIcon = () => (
    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8 19.5C9.1 19.5 10 18.6 10 17.5H6C6 18.6 6.9 19.5 8 19.5ZM14 13.5V8.5C14 5.4 12.4 2.9 9.5 2.2V1.5C9.5 0.7 8.8 0 8 0C7.2 0 6.5 0.7 6.5 1.5V2.2C3.6 2.9 2 5.4 2 8.5V13.5L0 15.5V16.5H16V15.5L14 13.5Z"
            fill="#474747"
        />
    </svg>
);
